import React, { forwardRef } from "react";
import { LucideProps } from "lucide-react";

const AGIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 24, color = "currentColor", strokeWidth = 2, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 724 724"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect
          width="724"
          height="724"
          rx="28"
          fill={color === "currentColor" ? "black" : color}
        />
        <path
          d="M243.25 265.239L178.367 463H126.1L214.741 224.442H248.001L243.25 265.239ZM297.155 463L232.108 265.239L226.865 224.442H260.453L349.585 463H297.155ZM294.206 374.196V412.7H168.209V374.196H294.206ZM579.696 338.314V432.853C575.982 437.331 570.247 442.192 562.492 447.435C554.737 452.569 544.742 456.992 532.508 460.706C520.275 464.42 505.474 466.277 488.106 466.277C472.705 466.277 458.669 463.765 445.998 458.74C433.328 453.606 422.405 446.124 413.229 436.293C404.163 426.463 397.172 414.447 392.257 400.247C387.342 385.938 384.884 369.608 384.884 351.258V336.348C384.884 317.997 387.232 301.667 391.929 287.358C396.735 273.049 403.562 260.979 412.41 251.148C421.258 241.318 431.798 233.835 444.032 228.701C456.266 223.568 469.865 221.001 484.829 221.001C505.583 221.001 522.623 224.387 535.949 231.159C549.275 237.822 559.434 247.107 566.424 259.013C573.524 270.81 577.894 284.354 579.532 299.646H531.853C530.652 291.563 528.358 284.518 524.972 278.51C521.585 272.503 516.725 267.806 510.389 264.42C504.163 261.034 496.08 259.341 486.14 259.341C477.948 259.341 470.63 261.034 464.185 264.42C457.85 267.697 452.497 272.557 448.128 279.002C443.759 285.447 440.427 293.42 438.134 302.923C435.84 312.426 434.693 323.459 434.693 336.02V351.258C434.693 363.71 435.894 374.742 438.297 384.354C440.701 393.857 444.251 401.886 448.947 408.44C453.754 414.884 459.652 419.745 466.643 423.022C473.633 426.299 481.771 427.937 491.056 427.937C498.811 427.937 505.256 427.282 510.389 425.971C515.632 424.66 519.838 423.076 523.005 421.219C526.282 419.253 528.795 417.396 530.542 415.649V373.377H485.649V338.314H579.696Z"
          fill="white"
        />
      </svg>
    );
  }
);

AGIcon.displayName = "AGIcon";

export default AGIcon;
